import script from "./ChartRankingView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartRankingView.vue?vue&type=script&setup=true&lang=js"

import "./ChartRankingView.vue?vue&type=style&index=0&id=fc19cad2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc19cad2"]])

export default __exports__